<template>
  <div id="app" >

    <nav class="navbar is-fixed-top is-light " role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
            <img src="https://www.rentas-ventas.com/assets/rvTotal.png" alt="logo" width="auto" height="100%" @click="getinmuebles">
      </div>

      <div id="barraNav" class="navbar-menu is-active">

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
                <div  v-if="hayAutorizado == false" @click="apagarTodas" >
                    <router-link to="/entrar" class="button is-info">
                        <span style="color:white"><i class="fas fa-door-open"></i> Anunciar / Entrar</span>
                    </router-link>
                </div>
                <div  v-if="hayAutorizado == true" @click="apagarTodas" >
                    <router-link to="/productosMios" class="button is-info">
                        <span style="color:white"><i class="fas fa-door-open"></i> Anunciar / Entrar</span>
                    </router-link>
                </div>                
            </div>
          </div>
        </div>
      </div>
    </nav>
                
    <br><br>
    <br>


    <div name="leeTodasLasinmueblesPublicas" class="column is-10 is-offset-1" align="center" id="todos" >
        <div class="column is-half">
            <br>
            <br>
            <input type="input is-primary"  class="input" v-model="aBuscar" placeholder="Buscar">

        </div>

        <div class="column is-half ">
            <div id="filtrar" v-on:click="verFiltros = !verFiltros">
                <button class="button is-small is-info">
                    <span class="icon">
                      <i class="fas fa-filter"></i>
                    </span>
                    <span>Filtrar</span> 
                </button>
                &nbsp{{paramCiudad}}&nbsp&nbsp {{paramFamilia}}&nbsp&nbsp {{paramTipo}}
            </div>
            <br>

            <transition name="verLosFiltros">
                <nav class="level" v-if="verFiltros">

                  <span class="level-item has-text-centered" >
                    <div>
                        <p class="heading">Sin-filtros</p>
                        <p class="subtitle">
                            <button class="button is-small" v-on:click="paramCiudad='';paramFamilia='';paramTipo='';verFiltros = false">Ver todos</button>
                        </p>
                    </div>
                  </span>&nbsp&nbsp

                  <span class="level-item has-text-centered">
                    <div>
                        <p class="heading">Ciudad</p>
                        <p >
                            <select class='select is-small' id="paramCiudad1" v-model="paramCiudad" style="width: 100px" v-on:change="guardaCookie('6452ciudad',paramCiudad)">
                                <option value=''>Todas</option>
                                <option value='Acapulco'>Acapulco</option>
                                <option value='Aguascalientes'>Aguascalientes</option>
                                <option value='Apodaca'>Apodaca</option>
                                <option value='Buenavista'>Buenavista</option>
                                <option value='Campeche'>Campeche</option>
                                <option value='Cancún'>Cancún</option>
                                <option value='Celaya'>Celaya</option>
                                <option value='Chalco'>Chalco</option>
                                <option value='Chetumal'>Chetumal</option>
                                <option value='Chicoloapan'>Chicoloapan</option>
                                <option value='Chihuahua'>Chihuahua</option>
                                <option value='Chilpancingo'>Chilpancingo</option>
                                <option value='Chimalhuacán'>Chimalhuacán</option>
                                <option value='Ciudad Acuña'>Ciudad Acuña</option>
                                <option value='Ciudad de México'>Ciudad de México</option>
                                <option value='Ciudad del Carmen'>Ciudad del Carmen</option>
                                <option value='Ciudad López Mateos'>Ciudad López Mateos</option>
                                <option value='Ciudad Madero'>Ciudad Madero</option>
                                <option value='Ciudad Obregón'>Ciudad Obregón</option>
                                <option value='Ciudad Valles'>Ciudad Valles</option>
                                <option value='Ciudad Victoria'>Ciudad Victoria</option>
                                <option value='Coatzacoalcos'>Coatzacoalcos</option>
                                <option value='Colima'>Colima</option>
                                <option value='Córdoba'>Córdoba</option>
                                <option value='Corregidora'>Corregidora</option>
                                <option value='Cuauhtémoc'>Cuauhtémoc</option>
                                <option value='Cuautitlán'>Cuautitlán</option>
                                <option value='Cuautitlán Izcalli'>Cuautitlán Izcalli</option>
                                <option value='Cuautla'>Cuautla</option>
                                <option value='Cuernavaca'>Cuernavaca</option>
                                <option value='Culiacán'>Culiacán</option>
                                <option value='Delicias'>Delicias</option>
                                <option value='Durango'>Durango</option>
                                <option value='Ecatepec'>Ecatepec</option>
                                <option value='El Marquez'>El Marques</option>
                                <option value='Ensenada'>Ensenada</option>
                                <option value='Fresnillo'>Fresnillo</option>
                                <option value='General Escobedo'>General Escobedo</option>
                                <option value='Gómez Palacio'>Gómez Palacio</option>
                                <option value='Guadalajara'>Guadalajara</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guaymas'>Guaymas</option>
                                <option value='Hermosillo'>Hermosillo</option>
                                <option value='Hidalgo del Parral'>Hidalgo del Parral</option>
                                <option value='Huimilpan'>Huimilpan</option>
                                <option value='Iguala'>Iguala</option>
                                <option value='Irapuato'>Irapuato</option>
                                <option value='Ixtapaluca'>Ixtapaluca</option>
                                <option value='Jiutepec'>Jiutepec</option>
                                <option value='Juárez'>Juárez</option>
                                <option value='La Paz'>La Paz</option>
                                <option value='Lagos de Moreno'>Lagos de Moreno</option>
                                <option value='León'>León</option>
                                <option value='Los Cabos'>Los Cabos</option>
                                <option value='Los Mochis'>Los Mochis</option>
                                <option value='Manzanillo'>Manzanillo</option>
                                <option value='Matamoros'>Matamoros</option>
                                <option value='Mazatlán'>Mazatlán</option>
                                <option value='Mérida'>Mérida</option>
                                <option value='Mexicali'>Mexicali</option>
                                <option value='Minatitlán'>Minatitlán</option>
                                <option value='Miramar'>Miramar</option>
                                <option value='Monclova'>Monclova</option>
                                <option value='Monterrey'>Monterrey</option>
                                <option value='Morelia'>Morelia</option>
                                <option value='Naucalpan'>Naucalpan</option>
                                <option value='Naucalpan de Juárez'>Naucalpan de Juárez</option>
                                <option value='Navojoa'>Navojoa</option>
                                <option value='Nezahualcóyotl'>Nezahualcóyotl</option>
                                <option value='Nogales'>Nogales</option>
                                <option value='Nuevo Laredo'>Nuevo Laredo</option>
                                <option value='Oaxaca de Juárez'>Oaxaca de Juárez</option>
                                <option value='Ojo de Agua'>Ojo de Agua</option>
                                <option value='Orizaba'>Orizaba</option>
                                <option value='Pachuca'>Pachuca</option>
                                <option value='Piedras Negras'>Piedras Negras</option>
                                <option value='Playa del Carmen'>Playa del Carmen</option>
                                <option value='Poza Rica de Hidalgo'>Poza Rica de Hidalgo</option>
                                <option value='Puebla'>Puebla</option>
                                <option value='Puerto Vallarta'>Puerto Vallarta</option>
                                <option value='Querétaro'>Querétaro</option>
                                <option value='Reynosa'>Reynosa</option>
                                <option value='Salamanca'>Salamanca</option>
                                <option value='Saltillo'>Saltillo</option>
                                <option value='San Cristóbal de las Casas'>San Cristóbal de las Casas</option>
                                <option value='San Francisco Coacalco'>San Francisco Coacalco</option>
                                <option value='San Juan Bautista Tuxtepec'>San Juan Bautista Tuxtepec</option>
                                <option value='San Juan del Río'>San Juan del Río</option>
                                <option value='San Juan del Los Lagos'>San Juan del Los Lagos</option>
                                <option value='San Luis Potosí'>San Luis Potosí</option>
                                <option value='San Luis Río Colorado'>San Luis Río Colorado</option>
                                <option value='San Miguel de Allende'>San Miguel de Allende</option>
                                <option value='San Nicolás de los Garza'>San Nicolás de los Garza</option>
                                <option value='San Pablo de las Salinas'>San Pablo de las Salinas</option>
                                <option value='San Pedro Garza García'>San Pedro Garza García</option>
                                <option value='Santa Catarina'>Santa Catarina</option>
                                <option value='Soledad de Graciano Sánchez'>Soledad de Graciano Sánchez</option>
                                <option value='Tampico'>Tampico</option>
                                <option value='Tapachula'>Tapachula</option>
                                <option value='Taxco'>Taxco</option>
                                <option value='Tehuacán'>Tehuacán</option>
                                <option value='Tepexpan'>Tepexpan</option>
                                <option value='Tepic'>Tepic</option>
                                <option value='Texcoco de Mora'>Texcoco de Mora</option>
                                <option value='Tijuana'>Tijuana</option>
                                <option value='Tlalnepantla'>Tlalnepantla</option>
                                <option value='Tlaquepaque'>Tlaquepaque</option>
                                <option value='Toluca'>Toluca</option>
                                <option value='Tonalá'>Tonalá</option>
                                <option value='Torreón'>Torreón</option>
                                <option value='Tulancingo de Bravo'>Tulancingo de Bravo</option>
                                <option value='Tuxtla'>Tuxtla</option>
                                <option value='Uruapan'>Uruapan</option>
                                <option value='Veracruz'>Veracruz</option>
                                <option value='Villa de Álvarez'>Villa de Álvarez</option>
                                <option value='Villa Nicolás Romero'>Villa Nicolás Romero</option>
                                <option value='Villahermosa'>Villahermosa</option>
                                <option value='Xalapa Enriquez'>Xalapa Enriquez</option>
                                <option value='Xico'>Xico</option>
                                <option value='Zacatecas'>Zacatecas</option>
                                <option value='Zamora'>Zamora</option>
                                <option value='Zapopan'>Zapopan</option>
                            </select>
                        </p>
                    </div>
                  </span>&nbsp&nbsp

                  <span class="level-item has-text-centered">
                    <div>
                        <p class="heading">Rentas-Ventas</p>
                        <p>
                            <select class="select is-small " id="paramFamilia1" v-model="paramFamilia" style="width: 100px" v-on:change="guardaCookie('6452familia',paramFamilia)">
                                <option value="">Todos</option>
                                <option value="Renta" >Rentas</option>
                                <option value="Traspaso">Traspasos</option>
                                <option value="Venta">Ventas</option>
                            </select>
                        </p>
                    </div>
                  </span>&nbsp&nbsp

                  <span class="level-item has-text-centered">
                    <div>
                        <p class="heading">Tipo</p>
                        <p >
                            <select class='select is-small' id="paramTipo1" v-model="paramTipo" style="width: 100px" v-on:change="guardaCookie('6452tipo',paramTipo)">
                                <option value="">Todos</option>
                                <option value="Bodega">Bodegas</option>
                                <option value="Casa">Casas</option>
                                <option value="Cuarto">Cuartos</option>
                                <option value="Departamento">Departamentos</option>
                                <option value="Local-comercial">Locales</option>
                                <option value="Oficina">Oficinas</option>
                                <option value="Terreno">Terrenos</option>
                            </select>
                        </p>
                    </div>
                  </span>&nbsp&nbsp

                  <span class="level-item has-text-centered" >
                    <div>
                        <p class="heading">.</p>
                        <p class="title">
                            <button v-on:click="verFiltros = false" >ok</button>
                        </p>
                    </div>
                  </span>
                </nav>
            </transition>
        </div>

            <div class="columns is-multiline">
                <div v-for="inmueble in buscarInmuebles" class="column is-one-third"> 
                    <div class="box" v-if="inmueble.descripcion47" >
                        <div id="encabezado" v-on:click="aumentarHit(inmueble.folio47, inmueble.mailContacto47, inmueble.descripcion47)">
                            <p v-if="inmueble.foto1">
                                <router-link :to="{name: 'verfotos1'}" v-if="inmueble.foto1" >
                                    <img v-bind:src="imagen(inmueble.foto1)" 
                                        class = "animate__animated animate__zoomIn " 
                                        style = "height:100%; max-height:200px;"
                                        v-on:click='pasaFolio(inmueble.folio47); apagarTodas();'
                                        alt=" foto no subida"
                                        onerror="this.src='https://www.rentas-ventas.com/assets/logoRVv.png'"
                                    >
                                </router-link>
                            </p>
                            <h1 class="title is-5">
                                <b>{{inmueble.tipo47}} en {{inmueble.ventaRenta}}</b>
                            </h1>
                            <p class="subtitle is-7" v-if="inmueble.nombre47">
                                <b>{{inmueble.nombre47}}</b>
                            </p>
                            <p>
                                <b>{{inmueble.colonia}}  {{inmueble.edo}} {{inmueble.pais}}</b>
                            </p>
                            <p>{{inmueble.mpio}}, {{inmueble.deleg}} {{inmueble.codigoPostal}}</p>
                            <p>
                                <b>
                                    <i class="fas fa-dollar-sign"></i> 
                                    {{formateaNumero(inmueble.importe1)}} {{inmueble.moneda1}}
                                </b>
                            </p>                
                            <p>
                                <span v-if="inmueble.m2C">{{formateaNumero(inmueble.m2C)}} M2 de construción</span>
                                <br>
                                <span v-if="inmueble.m2T">{{formateaNumero(inmueble.m2T)}} M2 de terreno</span>
                            </p>

                            <br>
                            <button class="button is-small is-primary" 
                                    v-on:click="cualver(inmueble.folio47);ver=!ver; aumentarHit(inmueble.folio47, inmueble.mailContacto47, inmueble.descripcion47)">Ver mas de este inmueble
                            </button>
                        </div>

                        <div class="column is-10">
                            <transition name="masDatos">
                                <div 
                                        class="card" 
                                        id="vermas" 
                                        v-if="viendo == inmueble.folio47" 
                                        style="background-color:#fde2f9;">

                                    <br>
                                    <div align="right">
                                        <button class="delete" v-on:click="viendo = ''" >
                                        </button>&nbsp&nbsp&nbsp&nbsp
                                    </div>
                                    <br>
                                    <p><b>{{inmueble.descripcion47}}</b></p>

                                    <p v-if="inmueble.direccion47"><br><b>Calle</b><br> {{inmueble.direccion47}}</p>
                                    
                                    <p v-if="inmueble.requisitos"><br><b>Requisitos</b><br>{{inmueble.requisitos}}</p>
                                    
                                    <p v-if="inmueble.videoYou"><br>
                                        <b>Video en Youtube</b><br>
                                        <a v-bind:href="inmueble.videoYou" target="_blank">{{inmueble.videoYou}}</a>
                                        <br><br>
                                    </p>

                                    <p v-if="inmueble.ubicacion"><br>
                                        <b>Ubicacion en Maps o Google earth</b><br>
                                        <a v-bind:href="inmueble.ubicacion" target="_blank">{{inmueble.ubicacion}}</a>
                                        <br><br>
                                    </p>                            

                                    <p v-if="inmueble.mailContacto47"><i class="fas fa-envelope"></i>
                                        <a :href="'mailto:' + inmueble.mailContacto47"> {{inmueble.mailContacto47}}</a>
                                    </p>

                                    <p v-if="inmueble.cel"><i class="fas fa-mobile-alt"> </i> 
                                        <a :href="'tel:' + inmueble.cel"> {{inmueble.cel}}</a>
                                    </p>
                                    <p v-if="inmueble.cel2"><i class="fas fa-phone-alt"> </i>
                                        <a :href="'tel:' + inmueble.cel2"> {{inmueble.cel2}}</a>
                                    </p>
                                    <p v-if="inmueble.web47">
                                        <a v-bind:href="'http://' + inmueble.web47">
                                                {{inmueble.web47}}
                                        </a> 
                                    </p>
                                        <span>
                                            <a v-bind:href="'https://wa.me/521' + inmueble.whatsappContacto
                                                    + '?text=Hola%20' + inmueble.contactoNom47 +'%20me%20interesa%20tu%20anuncio%20en%20rentas-ventas.com%20sobre:%20' + inmueble.nombre47 + '%20' + inmueble.codigoInterno" target="_blank"
                                            >
                                                <i class="fab fa-whatsapp fa-2x"></i>
                                            </a>    
                                        </span>&nbsp&nbsp&nbsp
                                        <span>
                                            <a v-bind:href="inmueble.facebook47" 
                                                v-if="inmueble.facebook47" 
                                                target="_blank"
                                            >
                                                <i class="fab fa-facebook fa-2x"></i>
                                            </a>
                                        </span>
                                    </p>

                                    <br> 

                                    <p v-if="inmueble.logo47">
                                        <figure class="image is-48x48" v-if="inmueble.logo47">
                                            <img v-bind:src="imagen(inmueble.logo47)">
                                        </figure> 
                                    </p>
                                    <br>
                                    <div align="center">
                                        <button class="delete" v-on:click="viendo = '' " >
                                        </button>
                                    </div>
                                    <br><br>

                                </div>
                            </transition>
                        </div>

                    <div id="enviarmeInfo">
                        <button class="button is-small is-info" v-on:click="verW = inmueble.folio47">Guardar en whatsapp</button>

                        <div v-if="verW == inmueble.folio47"> 
                            <h1 class="animate__animated animate__zoomIn ">
                                <div align="right"> 
                                    <button class="delete" v-on:click="verW = ''" >
                                    </button>
                                </div>                            
                                <span>Whatsapp a donde enviar</span>
                                    <span>
                                        <input class="input" type="telephone" name="miW" v-model="miWhatsapp" maxlength="15">
                                    </span>
                                </span>
                       
                                <br>
                                <span>
                                    <button class="button is-small" v-if="miWhatsapp.length > 9">
                                        <a v-bind:href="'http://wa.me/521' + miWhatsapp + '?text=Inmueble%20consultado %20en%20rentas-ventas%0A' + ligaMicro(inmueble.micrositio) + '%0A%0AWhatsapp%20del%20contacto%20' + ligaWhatsapp(inmueble.whatsappContacto) + '%0AMail%20del%20contacto%20' + inmueble.mailContacto47 " 
                                            target = "_blank" 
                                            v-on:click="verW = false; guardaW(miWhatsapp, inmueble.folio47, inmueble.mailContacto47)" 
                                            >Guardar
                                        </a>
                                    </button>
                                </span>
                                
                            </h1>    
                        </div>
                    </div>
                </div>
            </div>

          </div>

    </div>

    <router-view @autorizado = 'verAlAutorizado' 
                 @regresar= 'prender'
                 @apagar1 = 'apagarTodas' 
                 :mailAutorizado = 'usuarioVigente' 
                 :folioF = 'folioFoto' 
    >            
    </router-view>

    <footer class="footer">
        <div align="center">
            <small><strong>www.rentas-ventas.com Marca Registrada </strong> {{version}}-{{cuantosReg}}</small><br>
            <small>contacto: <a href="mailto:atencion@rentas-ventas.com">atencion@rentas-ventas.com</a></small>

        </div>    
        <br><br>
    </footer>

  </div>
</template>

<script>
    
import axios from 'axios';

export default {
    name: 'app',    
    created(){
        // leo si trae parametro con el formato http://www.algo.com?parametro1
        this.parametro1 = window.location.search.substring(1);  
    },
    mounted(){
        this.getinmuebles();

        // obtiene las cuquies
        this.paramFamilia = this.obtieneCookie('6452familia'); 
        this.paramTipo = this.obtieneCookie('6452tipo');
        this.paramCiudad = this.obtieneCookie('6452ciudad');
        this.miWhatsapp = this.obtieneCookie('visitante847RV');

        if (this.paramFamilia == 'undefined') this.paramFamilia = '';
        if (this.paramTipo == 'undefined') this.paramTipo = '';
        if (this.paramCiudad == 'undefined') this.paramCiudad = '';

    },
    updated(){
        //this.getinmuebles();
    },
    data () {
        return {
            parametro1:'',
            verMicrositio: false,
            inmueblesTodos:[],
            usuarioVigente:'',
            hayAutorizado: false,
            aBuscar:'',
            ver: false,
            viendo:'',
            viendo2:'',
            slogan:"",
            paramFamilia:"",
            paramTipo:"",
            paramCiudad:"",
            verW:'',
            miWhatsapp:"",
            verFiltros: false,
            folioFoto:'',
            cuantosReg: 0,
            version:"V3.3",
        }
    },
    methods:{
        getinmuebles(){
           // en el parametro1 trae el nombre de micrositio del producto, lo toma y lo pone en mayusculas
            var micro = this.parametro1.toLowerCase();              

            axios.get('https://www.rentas-ventas.com/leeProductos.php?mic50=' + micro + "&ran50=Visible" )
                .then((respuesta) => {
                    this.inmueblesTodos = respuesta.data;
                    this.cuantosReg = this.inmueblesTodos.length;
                    if (this.inmueblesTodos.length > 0 )
                    {
                        if(this.parametro1 != '') {
                            this.verMicrositio = true;
                        }
                        else this.verMicrositio = false;
                    }
                })
                .catch((error) =>{
                        alert('\n\n\ No se conecta internet ' + error);
                    });

        },
        cualver(cual){
            this.viendo = cual;
        },        
        verAlAutorizado(elAutorizado){
            this.usuarioVigente = elAutorizado;
            if (elAutorizado != '') this.hayAutorizado = true;
            document.getElementById("todos").style.display = "";
        },
        apagarTodas(){
            document.getElementById("todos").style.display = "none";
        },
        prender(){
            document.getElementById("todos").style.display = "";
        },
        imagen(cualImagen){
            return "https://www.rentas-ventas.com/fotosrentasventas/" + cualImagen;
        },
        micro(elMicro){
            return "https://www.rentas-ventas.com/?" + elMicro;
        },
        formateaFecha: function (fecha) {
        var d = new Date(fecha); 
        if (Date.parse(d)){
            // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
            d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
            d.setHours(0);
            var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
            d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
            return d} 
        else{return "sin fecha";}
        },
        formateaNumero(valor1) {
            return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 0, useGrouping:true});
        },
        guardaCookie(nombre, valor){
            var galleta = nombre + "=" + valor;
            document.cookie = galleta;
        },
        obtieneCookie(nombre){
            var cual = '';
            const cookies = Object.assign({}, ...document.cookie.split('; ').map(cookie => {
                const name = cookie.split('=')[0];
                const value = cookie.split('=')[1];
                if(nombre == name){
                    if (nombre != 'undefined') cual = value;
                }
                 
            }));
            return cual;
        },
        ligaWhatsapp(cual){
            return "http://wa.me/521" + cual;
        },
        ligaMicro(micro){
            return "https://www.rentas-ventas.com/?" + micro;
        },
        guardaW(visitante, visitado, visitadoM){
            // guarda como cookie el whatsapp del visitante
            this.guardaCookie("visitante847RV",visitante);
            // guarda en la base de datos el whatsapp del visitante 
            this.guardaWhatsappEnDB(visitante, visitado, visitadoM);
        },
        guardaWhatsappEnDB(elVisitante, elVisitadoFolio, elVisitadoM){
            axios.get('https://www.rentas-ventas.com/guardaVisitantes.php?vite=' + elVisitante + '&vidof=' + elVisitadoFolio + '&vidom=' + elVisitadoM);                
        },
        aumentarHit(folio, mailContacto, inmueble){
            axios.get('https://www.rentas-ventas.com/hits.php?fo478=' + folio + '&ma478=' + mailContacto + '&in478=' + inmueble); 
        },
        verMenu(){
            var barra = document.querySelector('#barraNav');
            barra.classList.toggle('is-active');
        },
        pasaFolio(folio){
            this.folioFoto = folio;
        },
        goBack() {
            this.$router.go(-1);
        }


    },
    computed:{
        buscarInmuebles: function (){
            return this.inmueblesTodos.filter((item) =>  
                   (item.nombre47.toUpperCase().includes(this.aBuscar.toUpperCase()) 
                || item.colonia.toUpperCase().includes(this.aBuscar.toUpperCase()) 
                || item.mpio.toUpperCase().includes(this.aBuscar.toUpperCase()) 
                || item.deleg.toUpperCase().includes(this.aBuscar.toUpperCase()) 
                || item.edo.toUpperCase().includes(this.aBuscar.toUpperCase()) 
                || item.descripcion47.toUpperCase().includes(this.aBuscar.toUpperCase())
                    ) 
                   && item.ventaRenta.includes(this.paramFamilia) 
                   && item.tipo47.includes(this.paramTipo) 
                   && item.mpio.includes(this.paramCiudad) 
            );
        }
   }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue